import { identity, prop } from 'ramda';
import { get } from 'js/utils/fetch.util';
import { useDispatch } from 'react-redux';
import { useEffect, useCallback } from 'react';
import { useDataFetch } from 'js/hooks/useDataFetch';
import { useAddTranslations } from 'js/hooks/i18n';
import { useUserSelector, useAppSelector } from 'js/store/hooks';
import { fetchApp } from 'js/components/system/App/store/actions';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

export const useWrapperAppInitialResources = () => {
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const addTranslations = useAddTranslations();
    const getCMSResourceURL = useGetCMSResourceURL();
    const requestStamp = useAppSelector(prop('requestStamp'));

    const onInitialResourcesResponse = useCallback((data) => {
        addTranslations({ translations: data.translations || {} });

        return data;
    }, [addTranslations]);

    const [{ isLoading, error, data: app }, refetch] = useDataFetch({
        fetch: get,
        shouldFetch: identity,
        initialIsLoading: false,
        onResponse: onInitialResourcesResponse
    });

    useEffect(() => {
        if (!app) {
            return;
        }

        if (app && window.Playtech.Variables) {
            dispatch(fetchApp({
                app: { ...window.Playtech.Variables, ...app },
                areInitialResourcesLoaded: true
            }));
        }
    }, [app, dispatch]);

    useEffect(() => {
        if (!app && !error && !isLoading && lang) {
            refetch(getCMSResourceURL(`/initialResources/wrapper/${lang}`, { t: requestStamp }));
        }
    }, [app, error, refetch, getCMSResourceURL, isLoading, lang, requestStamp]);

    return [{ isLoading, error, app }, refetch];
};
